export default __webpack_public_path__ + "static/media/no_content.d7214267.png";